<template>
    <div class="data page">
        <main>
            <form @submit.prevent="nextStep">
                <div class="container-fluid">
                    <div class="row pb-24">
                        <div class="col-12 col-lg-6 offset-lg-3">

                            <router-link :to="{name: 'step1' }" class="previous-step">
                                <span>Mijn gegevens</span>
                                <span>Stap 1 van 3</span>
                            </router-link>

                            <router-link :to="{name: 'step2' }" class="previous-step">
                                <span>Mijn woonsituatie</span>
                                <span>Stap 2 van 3</span>
                            </router-link>

                            <div class="step pt-24 ">
                                <div class="d-flex justify-content-between">
                                    <h1 class="h1">Mijn inkomensgegevens</h1>
                                    <h2 class="h1">Stap 3 van 3</h2>
                                </div>

                                <div class="step__part">
                                    <h3 class="h2">Mijn inkomenssituatie</h3>
                                    <div class="form-row">
                                        <div class="form-field w-100">
                                            <select required v-model="data.income_situation">
                                                <option :value="undefined" disabled selected>Kies optie</option>
                                                <option value="Geen">Geen</option>
                                                <option value="LoondienstOnbepaaldeTijd">Loondienst onbepaalde tijd</option>
                                                <option value="LoondienstBepaaldeTijd">Loondienst bepaalde tijd</option>
                                                <option value="Ondernemer">Ondernemer</option>
                                                <option value="Uitkering">Uitkering</option>
                                                <option value="Pensioen">Pensioen</option>
                                                <option value="InkomenUitEigenVermogen">Inkomen uit eigen vermogen</option>
                                                <option value="Anders">Anders</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="step__part">
                                    <div class="form-row">
                                        <div class="form-field w-100">
                                            <input type="text" v-model="data.company" maxlength="127" placeholder="Bedrijf of instantie">
                                        </div>
                                    </div>
                                </div>


                                <div class="step__part">
                                    <h3 class="h2">Mijn maandsalaris (bruto)</h3>
                                    <div class="form-row">
                                        <div class="form-field form-field__currency w-100">
                                            <span>€</span>
                                            <input type="number" v-model="data.monthly_income" placeholder="Vul maandsalaris in">
                                        </div>
                                    </div>
                                </div>

                                <div class="step__part">
                                    <h3 class="h2">Mijn persoonlijke verplichtingen</h3>
                                    <p>(bijv. alimentatie, lening niet zijnde hypotheek)</p>

                                    <div class="form-row">
                                      <p><small>Maandelijkse kosten</small></p>
                                        <div class="form-field form-field__currency w-100">
                                            <span>€</span>
                                            <input type="number" v-model="data.monthly_expenses" required placeholder="Maandelijkste kosten">
                                        </div>
                                    </div>
                                </div>
                                <div class="step__part">

                                    <div class="form-row">
                                      <p><small>Beschikbaar vermogen</small></p>
                                        <div class="form-field form-field__currency w-100">
                                          <span>€</span>
                                            <input type="number" v-model="data.equity" required placeholder="Beschikbaar vermogen">
                                        </div>
                                    </div>
                                </div>


                                <div v-if="partner">
                                    <div class="step__part">
                                        <h3 class="h2">Partner inkomenssituatie</h3>
                                        <div class="form-row">
                                            <div class="form-field w-100">
                                                <select required v-model="data.partner_income_situation">
                                                    <option :value="undefined" disabled selected>Kies optie</option>
                                                    <option value="Geen">Geen</option>
                                                    <option value="LoondienstOnbepaaldeTijd">Loondienst onbepaalde tijd</option>
                                                    <option value="LoondienstBepaaldeTijd">Loondienst bepaalde tijd</option>
                                                    <option value="Ondernemer">Ondernemer</option>
                                                    <option value="Uitkering">Uitkering</option>
                                                    <option value="Pensioen">Pensioen</option>
                                                    <option value="InkomenUitEigenVermogen">Inkomen uit eigen vermogen</option>
                                                    <option value="Anders">Anders</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="step__part">
                                        <div class="form-row">
                                            <div class="form-field w-100">
                                                <input type="text" v-model="data.partner_company" maxlength="127" placeholder="Bedrijf of instantie">
                                            </div>
                                        </div>
                                    </div>


                                    <div class="step__part">
                                        <h3 class="h2">Partner maandsalaris (bruto)</h3>
                                        <div class="form-row">
                                            <div class="form-field form-field__currency w-100">
                                                <span>€</span>
                                                <input type="number" v-model="data.partner_monthly_income" placeholder="">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="step__part">
                                        <h3 class="h2">Partner persoonlijke verplichtingen</h3>
                                        <p>(bijv. alimentatie, lening niet zijnde hypotheek)</p>

                                        <div class="form-row">
                                            <div class="form-field form-field__currency w-100">
                                              <span>€</span>
                                                <input type="number" v-model="data.partner_monthly_expenses" required placeholder="Maandelijkste kosten">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="step__part">

                                        <div class="form-row">
                                            <div class="form-field form-field__currency w-100">
                                              <span>€</span>
                                                <input type="number" v-model="data.partner_equity" required placeholder="Beschikbaar vermogen">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="$assignable.length" class="step__part">
                                    <h3 class="h2">Toewijsbaar</h3>
                                    <p>Op basis van uw verzamelinkomen zullen de volgende woningen WEL toegewezen kunnen worden.</p>

                                    <house-tile-status v-for="(object, i) in $assignable" :assignable="2" :key="i" :house="object"/>

                                    <div class="d-flex justify-content-center justify-content-lg-start w-100">
                                      <button type="button" @click="toPreferences" class="btn btn-grey">Wijzig voorkeuren</button>
                                    </div>
                                </div>

                                <div v-if="$likelyNotAssignable.length" class="step__part">
                                    <h3 class="h2">Wellicht toewijsbaar</h3>
                                    <p>Op basis van uw verzamelinkomen zullen de volgende woningen WELLICHT NIET toegewezen worden.</p>

                                    <house-tile-status v-for="(object, i) in $likelyNotAssignable" :assignable="1" :key="i" :house="object"/>

                                    <div class="d-flex justify-content-center justify-content-lg-start w-100">
                                      <button type="button" @click="toPreferences" class="btn btn-grey">Wijzig voorkeuren</button>
                                    </div>
                                </div>

                                <div v-if="$notAssignable.length" class="step__part">
                                    <h3 class="h2">Niet toewijsbaar</h3>
                                    <p>Op basis van uw verzamelinkomen zullen de volgende woningen NIET toegewezen worden.</p>

                                    <house-tile-status v-for="(object, i) in $notAssignable" :assignable="0" :key="i" :house="object"/>

                                    <div class="d-flex justify-content-center justify-content-lg-start w-100">
                                      <button type="button" @click="toPreferences" class="btn btn-grey">Wijzig voorkeuren</button>
                                    </div>
                                </div>

                            </div>
                        </div>
<!--                        <div class="col-3 pt-24 d-none d-lg-block ">-->
<!--                            <div class="h-100 d-flex justify-content-end">-->
<!--                                <div class="tooltip-wrap">-->
<!--                                    <a class="tooltip-btn">Info</a>-->
<!--                                    <div class="tooltip-content">-->
<!--                                        Tooltip over twee regels.-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-6">
                            <div class="step__footer text-right">
                                <button class="btn btn-primary">Volgende</button>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </main>
    </div>
</template>


<script>
    import HouseTileStatus from '../components/HouseTileStatus.vue'

    export default {
        components: {
            HouseTileStatus
        },
        data () {
            return {
                timer: null,
                data: {}
            }
        },
        mounted(){
            if(Object.keys(this.$store.state.form).length > 0){
                this.data = this.$store.state.form
            } else {
                this.prefill()
            }
            console.log(this.data)
        },
        watch: {
            data: {
                deep: true,
                handler () {
                    clearTimeout(this.timer)
                    this.timer = setTimeout(() => {
                        this.calculateRent()
                    }, 300)
                }
            }
        },
        computed: {
            partner () {
                if(this.data.partner_surname) {
                    return true
                }
                return false
            }
        },
        methods: {
            toPreferences(){
              this.saveData()
              this.$router.push({ name: 'preferences' })
            },
            nextStep () {
                this.saveData()
                this.$router.push({ name: 'step4' })
            },
            saveData  () {
                this.$store.commit('saveStep', this.data)
            },
            prefill () {
                if(!this.$user){
                    return
                }
                let user = this.$user

                // set user data
                Object.entries(user).forEach((row) => {
                    let name = row[0]
                    let value = row[1]
                    if(value && typeof value !== 'object'){
                        if(!this.data[name]) {
                            this.$set(this.data, name, value)
                        }
                    }
                })
            },
            calculateRent () {
                let data = {
                    monthlyIncome: this.data.monthly_income,
                    equity: this.data.equity,
                    monthlyExpenses: this.data.monthly_expenses,
                    monthlyIncomePartner: this.data.partner_monthly_income,
                    equityPartner: this.data.partner_equity,
                    monthlyExpensesPartner: this.data.partner_monthly_expenses,
                }
                this.axios.post(this.$route.params.selector_id + '/calculator', data).then((result) => {
                    console.log(result.data.maxRentalPrice)
                    this.$store.commit('rentalPrice', result.data.maxRentalPrice)
                    this.saveData()
                })
            }
        }
    }
</script>
